define("shared/utils/is-async-relation", ["exports", "@ember/object/proxy", "@ember-data/model"], function (_exports, _proxy, _model) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.isAsyncRelation = isAsyncRelation;
  0; //eaimeta@70e063a35619d71f0,"@ember/object/proxy",0,"@ember-data/model"eaimeta@70e063a35619d71f
  function isAsyncRelation(model) {
    const isModel = model.content instanceof _model.default;
    const promiseNotDefined = typeof model.promise !== 'undefined';
    return promiseNotDefined && isModel || model instanceof _proxy.default;
  }
  var _default = _exports.default = {
    isAsyncRelation
  };
});